import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Row, ToggleButton as Button } from '../styles';
export var Currency = function () {
    var _a = useFormContext(), setValue = _a.setValue, watch = _a.watch;
    var currency = watch('currency');
    var handleCurrency = function (newCurrency) {
        setValue('currency', newCurrency);
        if (newCurrency === undefined) {
            setValue('price_start', '');
            setValue('price_end', '');
        }
    };
    return (React.createElement(Row, null,
        React.createElement(Button, { className: "left " + (currency === 'UYU' ? 'isActive' : ''), onClick: function () { return handleCurrency('UYU'); } }, "$"),
        React.createElement(Button, { className: currency === 'USD' ? 'isActive' : '', onClick: function () { return handleCurrency('USD'); } }, "U$S"),
        React.createElement(Button, { className: "right " + (currency === undefined ? 'isActive' : ''), onClick: function () { return handleCurrency(undefined); } }, "Todas")));
};
